import { useEffect, useMemo, useState } from 'react';
import TableImage from 'src/components/atoms/TableImage';
import Page from 'src/components/layouts/Page';
// import PillBox from "src/components/atoms/PillBox";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Button from 'src/components/atoms/Button';
import ItemsGrid from 'src/components/layouts/ItemsGrid';
import MultipleViews from 'src/components/layouts/MultipleViews';
import EmptyPage from 'src/components/molecules/EmptyPage';
import TableFilterable from 'src/components/organisms/TableFilterable';
import css from './moveme.module.scss';

import SearchBar from 'src/components/organisms/SearchBar';
import { getCounts } from 'src/slices/info';
import {
  bulkDelete,
  bulkHide,
  getPendingItems,
  setView,
  updateFilter,
  updateItem,
} from 'src/slices/item';
import { checkPermissions } from 'src/slices/utils';

// we're using React.useMemo here to ensure that our data isn't recreated on every render.
// accessor is the "key" in the data

export default function Items(params) {
  const dispatch = useDispatch();
  const { isAdmin, permissions } = useSelector((state) => state.auth);
  const { pendingItems, pendingView } = useSelector((state) => state.item);
  const filter = useSelector((state) => state.item.filters.items);
  const { counts } = useSelector((state) => state.info);

  function handleDelete(message, deleteFunction) {
    const ConfirmActionModal = ({ closeToast, toastProps }) => (
      <div>
        Are you sure you want to delete this offer? This action cannot be undone.
        <div className={css.buttons}>
          <Button color="green" action={() => deleteFunction()} label={message}></Button>
          <Button color="red" label={'Dismiss'}></Button>
        </div>
      </div>
    );
    toast(ConfirmActionModal, { autoClose: false });
  }
  const bulkActions = [
    { value: (items) => dispatch(bulkDelete(items)), label: 'Bulk Delete' },
    {
      value: (items) => dispatch(bulkHide({ type: 'hide', items })),
      label: 'Bulk Hide',
    },
    {
      value: (items) => dispatch(bulkHide({ type: 'unhide', items })),
      label: 'Bulk Unhide',
    },
  ];

  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    dispatch(getCounts());
  }, []);

  useEffect(() => {
    dispatch(getPendingItems());
  }, [filter, dispatch]);

  const handleMore = () => {
    dispatch(updateFilter({ items: { limit: (page + 1) * filter.skip } }));
    setPage(page + 1);
  };

  useEffect(() => {
    dispatch(updateFilter({ items: { keyword: '', page: 1, skip: 200 } }));
  }, [dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: 'Image',
        accessor: 'photos',
        disableSortBy: true,
        width: '80px',
        Cell: (props) => (
          <TableImage
            iconUnicode=""
            src={props.cell.row.values.photos?.[0]}
            type="rect"
            alt={props.cell.row.values.name}
          />
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 'auto',
      },
      {
        Header: 'Price',
        accessor: 'price',
        Cell: (props) => `$${props.cell.row.values.price.toFixed(2)}`,
        width: 'auto',
      },
      {
        Header: 'Quantity',
        accessor: 'qty',
        Cell: (props) => `${props.cell.row.values.qty.value} ${props.cell.row.values.qty.units}`,
        width: 'auto',
      },
      // {
      // 	Header: 'Category',
      // 	accessor: 'category',
      // 	width: 'auto',
      // 	Cell: props => (
      // 		<Pill
      // 			label={props.cell.row.values.category || 'Other'}
      // 			color='normal'
      // 			variant='secondary'
      // 		/>
      // 	),
      // },

      /* {
        Header: "ID",
        accessor: "id",
      },*/
      {
        // Header: "Actions",
        Header: ' ',
        accessor: 'id',
        disableSortBy: true,
        Cell: (props) => (
          <div className={css['table-actions']}>
            {checkPermissions(permissions, { update: ['pendingItems'] }).hasPermission && (
              <>
                <Button
                  iconLeft="fad fa-pencil"
                  color="gray"
                  variant="secondary"
                  href={`/items/${props.cell.row.values.id}`}
                  size="s"
                />

                <Button
                  iconLeft={
                    props.cell.row.original.status == 'active' ? 'fas fa-eye' : 'fas fa-eye-slash'
                  }
                  color="gray"
                  variant="secondary"
                  size="s"
                  action={() =>
                    dispatch(
                      updateItem({
                        id: props.cell.row.values.id,
                        status: props.cell.row.original.status == 'active' ? 'hidden' : 'active',
                      }),
                    )
                  }
                />
              </>
            )}
            {/* {checkPermissions(permissions, { delete: ['pendingItems'] })
							.hasPermission && (
							<Button
								iconLeft='fad fa-trash-alt'
								color='red'
								variant='secondary'
								action={() =>
									handleDelete(`Delete '${props.cell.row.original.name}'`, () =>
										dispatch(deleteItem(props.cell.row.original.id))
									)
								}
							/>
						)} */}
          </div>
        ),
      },
      ,
    ],

    [],
  );
  // const tableInstance = useTable({ columns, data });

  return (
    <Page>
      {/* <TableFilterable
        columns={columns}
        data={data}
        cellPadding="8px"
        dataName="item"
        bulkActions={actions}
        createLink="/items/new"
      /> */}

      <MultipleViews
        // TODO: Card view default for mobile
        showControls
        defaultView="grid" // grid = card view
        isEmpty={pendingItems.length === 0}
        setView={(view) => dispatch(setView({ pending: view }))}
        view={pendingView}
        isLocked={!permissions.read.includes('pendingItems')}
        searchBar={
          <SearchBar
            onChange={(e) =>
              dispatch(
                updateFilter({
                  items: { keyword: e.target.value },
                }),
              )
            }
            value={filter.keyword}
            dataName="item"
            options={bulkActions}
            createLink="/items/new"
            view={pendingView}
            selected={selected}
            // canCreate={permissions.create.includes('items')}
          />
        }
        tableView={
          <TableFilterable
            columns={columns}
            data={pendingItems}
            cellPadding="8px"
            dataName="item"
            showBar={false}
            handleMore={handleMore}
            count={counts.items}
            setSelected={(selected) => setSelected(selected)}
          />
        }
        gridView={
          <>
            <ItemsGrid items={pendingItems} />
          </>
        }
        emptyView={
          <EmptyPage
            title="Your store currently doesn’t have any items to sell"
            text="Add items to your store for shoppers to buy"
            iconName="fad fa-inventory"
            button={
              <Button
                label="Create Item"
                iconLeft="fad fa-plus"
                href="/items/new"
                // action={!permissions.create.includes('items')}
                // disabled={!permissions.create.includes('items')}
                // color={!permissions.create.includes('items') ? 'gray' : 'blue'}
                // variant={
                // 	!permissions.create.includes('items') ? 'secondary' : 'primary'
                // }
              />
            }
          />
        }
        lockedView={
          <EmptyPage
            title="You don’t have permission to view anything on this page"
            text="Ask your employer for access"
            iconName="fad fa-lock"
          />
        }
      />
    </Page>
  );
}
